/**
 * @generated SignedSource<<e8a64d7a85f2f3b468e98e2515b37229>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type cursosLessonQuery$variables = {
  club: string;
  course: string;
  slug: string;
  username: string;
};
export type cursosLessonQuery$data = {
  readonly club: {
    readonly aiPersona: {
      readonly enabled: boolean;
    } | null | undefined;
    readonly showPoweredLogo: boolean;
  };
  readonly courseClass: {
    readonly " $fragmentSpreads": FragmentRefs<"courseLessonComments_lesson" | "cursos_lesson">;
  };
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"topnavRightPanel_user">;
  } | null | undefined;
};
export type cursosLessonQuery = {
  response: cursosLessonQuery$data;
  variables: cursosLessonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "club"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "course"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v4 = [
  {
    "kind": "Variable",
    "name": "club",
    "variableName": "club"
  },
  {
    "kind": "Variable",
    "name": "course",
    "variableName": "course"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPoweredLogo",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isCourseClass"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAccess",
  "storageKey": null
},
v13 = [
  (v10/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseSection",
  "kind": "LinkedField",
  "name": "section",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v21 = [
  (v20/*: any*/),
  (v10/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "NEWEST"
  }
],
v24 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isCommentInterface"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarFallback",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageFile",
  "kind": "LinkedField",
  "name": "photo",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v26/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    (v27/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentVote",
  "kind": "LinkedField",
  "name": "userVote",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vote",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "childrenCount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "OLDEST"
  }
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v39 = [
  "orderBy"
],
v40 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": "ACTIVE"
  }
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "cursosLessonQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "courseClass",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "username",
                "variableName": "username"
              }
            ],
            "kind": "FragmentSpread",
            "name": "cursos_lesson"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "courseLessonComments_lesson"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topnavRightPanel_user"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiPersona",
            "kind": "LinkedField",
            "name": "aiPersona",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "cursosLessonQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "courseClass",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "previousClass",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v15/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progress",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "classAccessControl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "user",
                    "variableName": "username"
                  }
                ],
                "concreteType": "CourseMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enrolledAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseMemberGroupMember",
                    "kind": "LinkedField",
                    "name": "memberGroup",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseMemberGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionReleaseTimeline",
                            "kind": "LinkedField",
                            "name": "releaseTimeline",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "daysToRelease",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "notAvailableBefore",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "CourseSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v15/*: any*/),
                      (v9/*: any*/),
                      (v16/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Course",
                        "kind": "LinkedField",
                        "name": "course",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "classes(status:\"ACTIVE\")"
                  }
                ],
                "storageKey": "sections(status:\"ACTIVE\")"
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v18/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Course",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "video",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v19/*: any*/)
                    ],
                    "type": "ExternalVideo",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rawID",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "muxId",
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageFile",
                        "kind": "LinkedField",
                        "name": "thumbnail",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoPlayback",
                        "kind": "LinkedField",
                        "name": "playback",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VideoFileTokens",
                            "kind": "LinkedField",
                            "name": "tokens",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "storyboard",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "thumbnail",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "VideoFile",
                    "abstractKey": null
                  },
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextClass",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v19/*: any*/),
                  (v16/*: any*/),
                  (v12/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "previousClass",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v16/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Attachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalName",
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commentCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "CommentInterfaceConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentInterfaceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": (v35/*: any*/),
                            "concreteType": "CommentInterfaceConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentInterfaceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v24/*: any*/),
                                      (v10/*: any*/),
                                      (v25/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v37/*: any*/),
                                  (v38/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "comments(first:3,orderBy:\"OLDEST\")"
                          },
                          {
                            "alias": null,
                            "args": (v35/*: any*/),
                            "filters": (v39/*: any*/),
                            "handle": "connection",
                            "key": "childrenComments__comments",
                            "kind": "LinkedHandle",
                            "name": "comments"
                          }
                        ],
                        "storageKey": null
                      },
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "comments(first:10,orderBy:\"NEWEST\")"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "filters": (v39/*: any*/),
                "handle": "connection",
                "key": "lessonComments_comments",
                "kind": "LinkedHandle",
                "name": "comments"
              }
            ],
            "type": "CourseContent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v16/*: any*/),
              (v18/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Quiz",
                "kind": "LinkedField",
                "name": "quiz",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": (v40/*: any*/),
                    "concreteType": "QuizQuestion",
                    "kind": "LinkedField",
                    "name": "questions",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      (v41/*: any*/),
                      {
                        "alias": null,
                        "args": (v40/*: any*/),
                        "concreteType": "QuizQuestionOption",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "options(enabled:\"ACTIVE\")"
                      }
                    ],
                    "storageKey": "questions(enabled:\"ACTIVE\")"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextClass",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v16/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "previousClass",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "CourseQuiz",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v27/*: any*/),
          (v26/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          (v28/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiPersona",
            "kind": "LinkedField",
            "name": "aiPersona",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "84102fda74a6c359653fc5647eea26a2",
    "id": null,
    "metadata": {},
    "name": "cursosLessonQuery",
    "operationKind": "query",
    "text": "query cursosLessonQuery(\n  $course: String!\n  $slug: String!\n  $club: String!\n  $username: String!\n) {\n  courseClass(course: $course, slug: $slug, club: $club) {\n    __typename\n    ...cursos_lesson_42ijek\n    ...courseLessonComments_lesson\n    id\n  }\n  user {\n    ...topnavRightPanel_user\n    id\n  }\n  club(slug: $club) {\n    aiPersona {\n      enabled\n      id\n    }\n    showPoweredLogo\n    id\n  }\n}\n\nfragment certificateEmitDialogFragment on Course {\n  id\n  name\n}\n\nfragment commentFragment on CommentInterface {\n  __isCommentInterface: __typename\n  id\n  content\n  author {\n    id\n    avatarFallback\n    displayName\n    photo {\n      signedUrl\n      id\n    }\n    username\n  }\n  parent {\n    __typename\n    id\n  }\n  votes\n  userVote {\n    vote\n  }\n  childrenCount\n  createdAt\n  __typename\n}\n\nfragment commentListFragment on CommentInterfaceConnection {\n  edges {\n    node {\n      id\n      ...comment_parentComment\n      __typename\n    }\n    cursor\n  }\n}\n\nfragment comment_childrenComments on CommentInterface {\n  __isCommentInterface: __typename\n  comments(first: 3, orderBy: OLDEST) {\n    edges {\n      node {\n        __typename\n        ...commentFragment\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment comment_parentComment on CommentInterface {\n  __isCommentInterface: __typename\n  ...commentFragment\n  ...comment_childrenComments\n  childrenCount\n}\n\nfragment courseLessonComments_lesson on CourseClass {\n  __isCourseClass: __typename\n  id\n  ... on CourseContent {\n    commentCount\n    comments(first: 10, orderBy: NEWEST) {\n      ...commentListFragment\n      edges {\n        node {\n          __typename\n          id\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}\n\nfragment courseLesson_lesson on CourseContent {\n  id\n  name\n  description\n  completed\n  section {\n    id\n  }\n  course {\n    slug\n    progress\n    completed\n    ...certificateEmitDialogFragment\n    id\n  }\n  ...courseVideo\n  video {\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  nextClass {\n    __typename\n    url\n    slug\n    canAccess\n    id\n  }\n  previousClass {\n    __typename\n    url\n    slug\n    canAccess\n    id\n  }\n  attachments {\n    id\n    size\n    originalName\n    signedUrl\n  }\n  ...courseLessonComments_lesson\n}\n\nfragment courseQuiz_quiz on CourseQuiz {\n  id\n  name\n  slug\n  description\n  completed\n  quiz {\n    id\n    questions(enabled: ACTIVE) {\n      id\n      title\n      description\n      active\n      options(enabled: ACTIVE) {\n        id\n        active\n        text\n      }\n    }\n  }\n  course {\n    slug\n    ...certificateEmitDialogFragment\n    id\n  }\n  nextClass {\n    __typename\n    canAccess\n    slug\n    id\n  }\n  previousClass {\n    __typename\n    canAccess\n    slug\n    id\n  }\n}\n\nfragment courseSectionsPreview on Course {\n  id\n  sections(status: ACTIVE) {\n    id\n    ...courseSectionsPreview_section\n  }\n}\n\nfragment courseSectionsPreview_lesson on CourseClass {\n  __isCourseClass: __typename\n  id\n  slug\n  name\n  canAccess\n  completed\n  course {\n    slug\n    id\n  }\n}\n\nfragment courseSectionsPreview_section on CourseSection {\n  id\n  name\n  classes(status: ACTIVE) {\n    __typename\n    id\n    name\n    completed\n    ...courseSectionsPreview_lesson\n  }\n}\n\nfragment courseVideo on CourseContent {\n  video {\n    ... on ExternalVideo {\n      url\n    }\n    ... on VideoFile {\n      id\n      rawID\n      muxId\n      url\n      status\n      thumbnail {\n        signedUrl\n        id\n      }\n      playback {\n        playback\n        tokens {\n          playback\n          storyboard\n          thumbnail\n        }\n      }\n      ...courseVideo_video\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment courseVideo_video on VideoFile {\n  id\n  rawID\n  muxId\n  url\n  status\n  playback {\n    playback\n    tokens {\n      playback\n      storyboard\n      thumbnail\n    }\n  }\n}\n\nfragment cursos_lesson_42ijek on CourseClass {\n  __isCourseClass: __typename\n  id\n  name\n  canAccess\n  section {\n    id\n  }\n  previousClass {\n    __typename\n    completed\n    id\n  }\n  course {\n    name\n    progress\n    slug\n    classAccessControl\n    member(user: $username) {\n      id\n      enrolledAt\n      memberGroup {\n        group {\n          releaseTimeline {\n            section {\n              id\n            }\n            daysToRelease\n            notAvailableBefore\n          }\n          id\n        }\n        id\n      }\n    }\n    ...courseSectionsPreview\n    id\n  }\n  ... on CourseContent {\n    ...courseLesson_lesson\n  }\n  ... on CourseQuiz {\n    ...courseQuiz_quiz\n  }\n  ...lessonBlocked_lesson\n  __typename\n}\n\nfragment lessonBlocked_lesson on CourseClass {\n  __isCourseClass: __typename\n  name\n}\n\nfragment profileUpdateDialog_user on User {\n  firstName\n  lastName\n  username\n  avatarFallback\n  photo {\n    id\n    signedUrl\n  }\n  email\n  bio\n}\n\nfragment topnavRightPanel_user on User {\n  photo {\n    signedUrl\n    id\n  }\n  avatarFallback\n  ...profileUpdateDialog_user\n}\n"
  }
};
})();

(node as any).hash = "4879e76da4431068585fa688ad549069";

export default node;
